import useAppNavigate from "../../components/router/use-app-navigate";
import ProductList from "../../components/product/list";
import { useParams, useLocation } from "react-router-dom";

export default function Purchase() {
  const { type: typeParam } = useParams<{ type?: string }>();
  const location = useLocation();
  const { type: typeState } = location.state || {};

  const type = typeState || typeParam;

  let navigate = useAppNavigate();

  return (
    <ProductList
      type={type}
      isShop={false}
      onSuccess={(id) => navigate(`/payment/${id}`)}
    />
  );
}
